
module.exports = require('./dist/checkout.lib');
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/paypal-checkout/index.js
// module id = 339
// module chunks = 1